// extracted by css-extract-rspack-plugin
export default {"configRow":"jnYtJSXyoCYvf1fz","configRowLabel":"oK_Yhejv_D00YG2S","configRowInGrid":"DUAThmqbUyYNgeCT","configRowControl":"LCn06nejtHUnWqji"};